import {HttpErrorResponse} from '@angular/common/http';
import {Component, OnDestroy} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {TargetService} from '../../../target/target.service';
import {SubscriptionHandler} from '../../../utils/subscription-handler';

@Component({
  selector: 'app-ttd-partner--create',
  templateUrl: './ttd-partner-create.component.html',
  styleUrls: ['./ttd-partner-create.component.scss']
})
export class TtdPartnerCreateComponent implements OnDestroy {
  private subscriptionHandler = new SubscriptionHandler();

  partnerId = new FormControl('', Validators.required);
  partnerName = new FormControl('', Validators.required);
  errorMessage!: string;

  constructor(private targetsActions: TargetService,
              private dialogRef: MatDialogRef<TtdPartnerCreateComponent>) {
  }

  ngOnDestroy() {
    this.subscriptionHandler.unsubscribe();
  }

  reset(): void {
    this.partnerName.reset();
    this.partnerId.reset();
  }

  create(): void {
    this.subscriptionHandler.subscription = this.targetsActions.createTtdBuyer({
      partnerName: this.partnerName.value,
      partnerId: this.partnerId.value
    })
      .subscribe({
        next: () => {
          this.dialogRef.close();
        },
        error: (error: HttpErrorResponse) => {
          if (error.status === 409) {
            this.errorMessage = `PartnerId ${this.partnerId.value} exists.`;
          } else {
            this.errorMessage = error.error.message;
          }
        }
      });
  }

  getErrorMessage(): string {
    const requiredMessage = 'You must enter a value';

    if (this.partnerName.hasError('required')
      || this.partnerId.hasError('required')) {
      return requiredMessage;
    }

    return '';
  }

}

